import { defineStore } from 'pinia';
import { ref } from 'vue';

import { crossbeamApi } from '@/api';
import { captureException } from '@/errors';
import { ls } from '@/local_storage';
import { initStore } from '@/stores/store-utils';
import { PartnerSuggestion } from '@/types/partner_suggestions';

export const usePartnerSuggestionsStore = defineStore(
  'PartnerSuggestionsStore',
  () => {
    const suggestions = ref<PartnerSuggestion[]>([]);

    const { initError, ready, readySync, running, refresh } = initStore(
      async () => {
        try {
          const { data, error } = await crossbeamApi.GET(
            '/v0.3/partner-suggestions',
          );
          if (error) {
            captureException(error);
            return;
          }
          suggestions.value = data.items;
          ls.suggestedPartners.set({ partnerSuggestions: suggestions.value });
        } catch (err) {
          captureException(err as Error);
        }
      },
    );

    return {
      error: initError,
      ready,
      readySync,
      running,
      refreshPartnerSuggestions: refresh,
      suggestions,
    };
  },
);
